import React, {Component} from 'react'
import ReactTelInput from 'react-telephone-input';

import flags from '../../../images/flags.png';
import Registry from '../../../registry/index';

import './style.scss';

class RequestSMSForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activationOnly: !!props.activationOnly,
            formData: {
                phone: ''
            },
            error: '',
        };

        this.state = {
            ...this.state,
            captchaToken: null,
        };

        this.captchaRef = React.createRef();
        this.widgetId = null;

        this._onError = this._onError.bind(this);
        this._onSuccess = this._onSuccess.bind(this);
    }

    componentDidMount() {
        if (typeof window === 'undefined') return;

        let intervalId = null;

        const initCaptcha = () => {
            if (this.captchaRef && window.turnstile && this.widgetId === null) {
                this.widgetId = window.turnstile.render(this.captchaRef, {
                    sitekey: '0x4AAAAAACYQvImRXMQ5dwGT',
                    callback: (token) => {
                        this.setState({ captchaToken: token, error: '' });
                    },
                    'expired-callback': () => {
                        this.setState({ captchaToken: null });
                    }
                });

                clearInterval(intervalId);
            }
        };

        intervalId = window.setInterval(initCaptcha, 100);

        this._intervalCleanup = () => clearInterval(intervalId);
    }

    componentWillUnmount() {
        if (this._intervalCleanup) this._intervalCleanup();

        if (window.turnstile && this.widgetId !== null) {
            window.turnstile.remove(this.widgetId);
        }
    }

    sendData(e) {
        e.preventDefault();

        if (!this.state.captchaToken) {
            this.setState({ error: 'Captcha error' });
            return;
        }

        let siteInterface = Registry.get('siteInterface');
        siteInterface.activateRequestSMS({
            ...this.state.formData,
            captcha: this.state.captchaToken
        })
            .then(this._onSuccess)
            .catch(this._onError)
            .finally(() => {
                if (window.turnstile && this.widgetId) {
                    window.turnstile.reset(this.widgetId);
                    this.setState({ captchaToken: null });
                }
            });
    }

    _onSuccess(_response) {
        this.setState({
            formData: {
                phone: '',
            },
            error: ''
        });
        this.props.switchTab(4)
    }

    _onError(exception) {
        this.setState({
            error: exception.message,
            captchaToken: null
        });

        if (window.turnstile && this.widgetId !== null) {
            window.turnstile.reset(this.widgetId);
        }
    }

    handleChange (phone) {
        this.setState({
            formData: {
                phone: phone
            },
            error: ''
        });
    }

    render() {
        let lang = Registry.get('locale');

        let { 
            error,
            formData,
            activationOnly,
            captchaToken
        } = this.state;
        let disabledEnter = !formData.phone || !captchaToken ? 'disabled' : '';

        return (
            <div className="request-sms-form content">
                {!activationOnly ? <a href="#" className="tab-back" onClick={() => this.props.switchTab(4)}>{lang.receive_sms_with_code}</a> : <div className="empty-tab-back"></div>}
                {activationOnly ? <p className="text">{lang.enter_phone_to_receive_sms}</p> : null}
                <form onSubmit={e => this.sendData(e)}>
                    <ReactTelInput
                        name="phone"
                        defaultCountry="fr"
                        flagsImagePath={flags}
                        onChange={e => this.handleChange(e)}
                    />
                    <div ref={el => (this.captchaRef = el)} style={{margin: '20px 0'}}/>
                    <button
                        className="popup-button primary"
                        disabled={disabledEnter}
                        onClick={e => this.sendData(e)}
                    >{lang.send}</button>
                </form>

                <p className="error" dangerouslySetInnerHTML={{__html: error}} />
            </div>
        )
    }
}

export default RequestSMSForm;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/AnonymousLoginPopup/RequestSMSForm.js